// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TelegramLinker — small UI block embedded in the Notification Center. */

.telegram-linker {
  /* Inherits visual style from .notification-emails-section. */
}

.telegram-linker-empty-hint {
  color: #6b7280;
  font-size: 13px;
  margin: 0 0 12px 0;
}

.telegram-linker-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  max-width: 500px;
  margin-bottom: 12px;
}

.telegram-linker-row {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  background-color: #ffffff;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.telegram-linker-row:hover {
  border-color: #515151;
  background-color: #ffffff;
}

.telegram-linker-row-label {
  flex: 1 1;
  font-size: 14px;
  color: #1f2937;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.telegram-linker-row-meta {
  color: #9ca3af;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.telegram-linker-row-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  background-color: transparent;
  border: none;
  color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
  padding: 0;
  border-radius: 50%;
  font-size: 14px;
  transition: color 0.15s ease, background-color 0.15s ease;
}

.telegram-linker-row-remove:hover:not(:disabled) {
  color: rgba(0, 0, 0, 0.87);
  background-color: rgba(0, 0, 0, 0.04);
}

.telegram-linker-row-remove:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.telegram-linker-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.telegram-linker-connect-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #5616ea;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease, opacity 0.15s ease;
}

.telegram-linker-connect-btn:hover:not(:disabled) {
  background-color: #4310c4;
}

.telegram-linker-connect-btn:disabled {
  opacity: 0.7;
  cursor: progress;
}

.telegram-linker-refresh-btn {
  background-color: transparent;
  color: #5616ea;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.telegram-linker-refresh-btn:hover {
  background-color: #f5f3ff;
}

.telegram-linker-help {
  color: #6b7280;
  font-size: 12px;
  margin: 8px 0 0 0;
}

.telegram-linker-error {
  color: #b91c1c;
  font-size: 13px;
  margin: 8px 0 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/TelegramLinker.css"],"names":[],"mappings":"AAAA,yEAAyE;;AAEzE;EACE,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,yBAAyB;EACzB,gEAAgE;AAClE;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB","sourcesContent":["/* TelegramLinker — small UI block embedded in the Notification Center. */\r\n\r\n.telegram-linker {\r\n  /* Inherits visual style from .notification-emails-section. */\r\n}\r\n\r\n.telegram-linker-empty-hint {\r\n  color: #6b7280;\r\n  font-size: 13px;\r\n  margin: 0 0 12px 0;\r\n}\r\n\r\n.telegram-linker-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  width: 100%;\r\n  max-width: 500px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.telegram-linker-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  padding: 8px 12px;\r\n  border: 1px solid rgba(0, 0, 0, 0.23);\r\n  border-radius: 4px;\r\n  background-color: #ffffff;\r\n  transition: border-color 0.15s ease, background-color 0.15s ease;\r\n}\r\n\r\n.telegram-linker-row:hover {\r\n  border-color: #515151;\r\n  background-color: #ffffff;\r\n}\r\n\r\n.telegram-linker-row-label {\r\n  flex: 1;\r\n  font-size: 14px;\r\n  color: #1f2937;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.telegram-linker-row-meta {\r\n  color: #9ca3af;\r\n  font-size: 12px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.telegram-linker-row-remove {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  background-color: transparent;\r\n  border: none;\r\n  color: rgba(0, 0, 0, 0.6);\r\n  cursor: pointer;\r\n  padding: 0;\r\n  border-radius: 50%;\r\n  font-size: 14px;\r\n  transition: color 0.15s ease, background-color 0.15s ease;\r\n}\r\n\r\n.telegram-linker-row-remove:hover:not(:disabled) {\r\n  color: rgba(0, 0, 0, 0.87);\r\n  background-color: rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.telegram-linker-row-remove:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n.telegram-linker-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.telegram-linker-connect-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background-color: #5616ea;\r\n  color: #ffffff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 8px 14px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s ease, opacity 0.15s ease;\r\n}\r\n\r\n.telegram-linker-connect-btn:hover:not(:disabled) {\r\n  background-color: #4310c4;\r\n}\r\n\r\n.telegram-linker-connect-btn:disabled {\r\n  opacity: 0.7;\r\n  cursor: progress;\r\n}\r\n\r\n.telegram-linker-refresh-btn {\r\n  background-color: transparent;\r\n  color: #5616ea;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  padding: 8px 10px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s ease;\r\n}\r\n\r\n.telegram-linker-refresh-btn:hover {\r\n  background-color: #f5f3ff;\r\n}\r\n\r\n.telegram-linker-help {\r\n  color: #6b7280;\r\n  font-size: 12px;\r\n  margin: 8px 0 0 0;\r\n}\r\n\r\n.telegram-linker-error {\r\n  color: #b91c1c;\r\n  font-size: 13px;\r\n  margin: 8px 0 0 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
